import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import './AssetDetails.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FromFieldText from '../../../atoms/FromFieldText';
import {
    getAllImagesByTag,
    getAllocation,
    getDepreciation,
    getPVInformation,
    getRepairLog,
    getSignedImageUrl,
    getSTPI
} from '../../../services/asset.service';
import {getDepartmentList} from '../../../services/user.service';
import {DataGrid, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import FromFieldNumber from '../../../atoms/FromFieldNumber';
import * as CryptoJS from "crypto-js";
import FromFieldTextER from "../../../atoms/FromFieldTextER";

/* ─── Date Helpers (unchanged) ─── */
var months = {
    '1': 'JAN', '2': 'FEB', '3': 'MAR', '4': 'APR', '5': 'MAY', '6': 'JUN', '7': 'JUL',
    '8': 'AUG', '9': 'SEP', '10': 'OCT', '11': 'NOV', '12': 'DEC'
};

Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        dte.setMinutes(dte.getMinutes() + dte.getTimezoneOffset() + 330);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

/* ─── Column Definitions (unchanged) ─── */
const columns = [
    {"field": "id", "hideable": true, "hide": true, "headerName": "Sl No"},
    {"field": "year", "hideable": true, "hide": true, "headerName": "Year"},
    {"field": "month", "hide": true, "headerName": "Month", valueGetter: (parms) => months[parms.row.month]},
    {"field": "tag", "hide": false, "headerName": "TAG", width: 250},
    {
        "field": "depreciation_date", "hide": false, "headerName": "Date", width: 150,
        renderCell: (params) => <p>{params.value ? getFormatedDate(params.value) : ''}</p>
    },
    {"field": "asset_ob", "hide": false, "headerName": "Asset OB"},
    {"field": "asset_added_value", "hide": false, "headerName": "Asset Added Value"},
    {"field": "asset_deleted_value", "hide": false, "headerName": "Asset Deleted Value"},
    {"field": "asset_cb", "hide": false, "headerName": "Asset CB"},
    {"field": "depreciation_ob", "hide": false, "headerName": "Depreciation OB"},
    {"field": "depreciation_added_value", "hide": false, "headerName": "Depreciation Added Value"},
    {"field": "depreciation_deleted_value", "hide": false, "headerName": "Depreciation Deleted Value"},
    {"field": "depreciation_adjusted_value", "hide": false, "headerName": "Depreciation Adjusted Value"},
    {"field": "depreciation_cb", "hide": false, "headerName": "Depreciation CB"},
    {"field": "wdv_ob", "hide": false, "headerName": "WDV OB"},
    {"field": "wdv_cb", "hide": false, "headerName": "WDV CB"}
];

const columns1 = [
    {"field": "tag", "hide": false, "headerName": "TAG", width: 250},
    {"field": "assignment_no", "hide": false, "headerName": "Assignment No", width: 250},
    {"field": "repair_category", "hide": false, "headerName": "Repair Category", width: 250},
    {
        "field": "created_at", "hide": false, "headerName": "Created Date", width: 150,
        renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
    },
];

const columns2 = [
    {"field": "tag", "hide": false, "headerName": "TAG", width: 250},
    {"field": "site_id", "hide": false, "headerName": "Site ID", width: 250},
    {"field": "method", "hide": false, "headerName": "Method", width: 250},
    {"field": "last_verification_remarks", "hide": false, "headerName": "Verification Method", width: 250},
    {"field": "status_of_verification", "hide": false, "headerName": "Status of Verification", width: 250},
    {"field": "verification_mode", "hide": false, "headerName": "Verification Mode", width: 250},
    {
        "field": "created_at", "hide": false, "headerName": "Verified Date", width: 150,
        renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
    },
    {
        "field": "last_verification_date", "hide": false, "headerName": "Last Verification Date", width: 150,
        renderCell: (params) => <p>{getFormatedDate(params.row.last_verification_date)}</p>
    },
];

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport/>
        </GridToolbarContainer>
    );
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function AssetDetails() {
    /* ─── All State (unchanged) ─── */
    const [value, setValue] = useState(0);
    const [tag, setTag] = useState(0);
    const [assetInfo, setAssetInfo] = useState(0);
    const [assetDepriciation, setAssetDepriciation] = useState([]);
    const [assetRepairLogs, setAssetRepairLog] = useState([]);
    const [pvInformationLog, setPVInformationLog] = useState([]);
    const [imagelist, setImageList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allocationInfo, setAllocationInfo] = useState(0);
    const [EncryptData1, setEncryptData1] = useState([]);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [head_title, setHeadTitle] = useState('');
    const [imageName, setImageName] = useState('');

    /* ─── All useEffect & Handlers (unchanged logic) ─── */
    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedTagid = decrypt_data.tag;
            getTagAutoInfo(decryptedTagid);
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getDepartmentList(oData).then(res => {
            if (res?.data?.data?.length) setDepartments(res.data.data);
        });
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    var onCellEditStopFn = (event, newCell) => {
        var obj = {};
        obj[newCell.field] = event.target.value;
    }

    const getTagAutoInfo = function (Tag) {
        const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
        let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': Tag, 'module': 'Addition'},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        setEncryptData1(decryptedBytes);
        let oData = {'token': EncryptData1}
        getSTPI(oData).then(function (res) {
            if (res?.data?.data) {
                setErrMsg('');
                var {assetInfo} = res.data.data;
                setAssetInfo(assetInfo);
            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
        })
        try {
            setLoading('..');
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'tag': Tag},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}
            getDepreciation(oData).then(function (res) {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data?.assetInfo && data?.assetDeprisiation) {
                        setAssetInfo(data.assetInfo);
                        setAssetDepriciation(data.assetDeprisiation);
                    } else {
                        setErrMsg('Assets Not Found');
                    }
                }
            });
            getRepairLog(oData).then(function (res) {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data?.assetRepairLog) setAssetRepairLog(data.assetRepairLog);
                }
            });
            getPVInformation(oData).then(function (res) {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data?.pvInformationLog) setPVInformationLog(data.pvInformationLog);
                }
            });
            getAllImagesByTag(oData).then(function (res) {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data.length) setImageList(data);
                }
            });
            getAllocation(oData).then(function (res) {
                var info = {};
                if (res?.data?.data?.assetInfo) {
                    info = res.data.data.transferInfo;
                    setAllocationInfo(info);
                } else {
                    setAllocationInfo({});
                }
            });
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setAssetDepriciation('');
            setAllocationInfo({});
        }
    }

    const getTagInfo = function () {
        if (tag == '') {
            setErrMsg('Enter Assets');
        } else {
            setErrMsg('');
            try {
                setLoading('..');
                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'tag': tag},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                let oData = {'token': EncryptData}
                getDepreciation(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data?.assetInfo && data?.assetDeprisiation) {
                            setErrMsg('');
                            setAssetInfo(data.assetInfo);
                            setAssetDepriciation(data.assetDeprisiation);
                        } else {
                            setAssetInfo({});
                            setErrMsg('Assets Not Found');
                        }
                    }
                });
                getRepairLog(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data?.assetRepairLog) setAssetRepairLog(data.assetRepairLog);
                    }
                });
                getPVInformation(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data?.pvInformationLog) setPVInformationLog(data.pvInformationLog);
                    }
                });
                getAllImagesByTag(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data.length) setImageList(data);
                    }
                });
                getAllocation(oData).then(function (res) {
                    var info = {};
                    if (res?.data?.data?.assetInfo) {
                        info = res.data.data.transferInfo;
                        setAllocationInfo(info);
                    } else {
                        setAllocationInfo({});
                    }
                });
                setLoading(false);
            } catch (err) {
                setLoading(false);
                setAssetDepriciation('');
            }
            try {
                setLoading('..');
                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'tag': tag},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                let oData1 = {'token': EncryptData}
                getAllocation(oData1).then(function (res) {
                    var info = {};
                    if (res?.data?.data?.assetInfo) {
                        info = res.data.data.transferInfo;
                        setAllocationInfo(info);
                    } else {
                        setAllocationInfo({});
                    }
                });
                setLoading(false);
            } catch (err) {
                setLoading(false);
                setAllocationInfo({});
            }
        }
    }

    const sSub_Module_Id = sessionStorage.getItem('LoggedInSubModuleId');
    const aSub_Module_Id = sSub_Module_Id.split(',');

    const getSignedUrl = (key) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'fileKey': key},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = {'token': EncryptData}
        getSignedImageUrl(oData1).then(function (res) {
            if (res?.data?.url) setPreviewImage(res.data.url);
        });
    };

    const handleDownloadFile = async (imageId, id) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'fileKey': imageId},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = {'token': EncryptData}
        try {
            const res = await getSignedImageUrl(oData1);
            if (res?.data?.url) {
                const url = res.data.url;
                const response = await fetch(url);
                const blob = await response.blob();
                const filename = imageId.substring(imageId.lastIndexOf('/') + 1);
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
            }
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    const handlePreviewImage = async (imageId, imageName, headtitle) => {
        try {
            setHeadTitle(headtitle);
            setImageName(imageName);
            setPreviewImage(imageId);
            setShowModal(true);
        } catch (error) {
            console.error('Error previewing image:', error);
        }
    };

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="asset-details-page">

            {/* ══ ALERTS ══ */}
            {success && (
                <div className="alert alert-success" role="alert" style={{marginBottom: '16px'}}>
                    <i className="bi bi-check-circle-fill"/> {success}
                </div>
            )}
            {errMsg && (
                <div className="alert alert-danger" role="alert" style={{marginBottom: '16px'}}>
                    <i className="bi bi-exclamation-triangle-fill"/> {errMsg}
                </div>
            )}

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-file-earmark-text-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Asset Details</h5>
                        <p className="al-page-subtitle">View comprehensive asset information and history</p>
                    </div>
                </div>
                {(Tag !== '' && Tag !== null) && (
                    <div className="al-header-actions">
                        <a href={'/single-asset?tag=' + Tag}>
                            <button className='al-btn al-btn-primary al-btn-sm'>
                                <i className="bi bi-pencil-square"/> Edit
                            </button>
                        </a>
                        <a href={'/asset-list'}>
                            <button className='al-btn al-btn-outline al-btn-sm'>
                                <i className="bi bi-arrow-left"/> Back
                            </button>
                        </a>
                        {(aSub_Module_Id.indexOf('100') > -1) && (
                            <a href={'/audit-log-view?method=Addition&back_url=asset-details&tag=' + Tag}>
                                <button className='al-btn al-btn-warning al-btn-sm'>
                                    <i className="bi bi-clock-history"/> Audit Log
                                </button>
                            </a>
                        )}
                    </div>
                )}
            </div>

            {/* ══ SEARCH SECTION (if no TAG in URL) ══ */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="al-filter-card" id="al-search-card">
                    <div className="al-filter-card-header">
                        <span className="al-filter-card-title">
                            <i className="bi bi-search"/> Search Asset by TAG
                        </span>
                    </div>
                    <div className="al-filter-card-body">
                        <div className="al-filter-grid" style={{gridTemplateColumns: '1fr 1fr auto'}}>
                            <div className="al-filter-group">
                                <label className="al-filter-label">Asset TAG</label>
                                <input
                                    onChange={function (event) { setTag(event.target.value) }}
                                    inputValue={assetInfo.tag}
                                    type="text"
                                    className="al-form-input"
                                    placeholder='Enter the asset TAG'
                                />
                            </div>
                            <div className="al-filter-group" style={{display: 'flex', alignItems: 'flex-end'}}>
                                <label class="al-filter-label">&nbsp;</label>
                                <button onClick={getTagInfo} className='al-btn al-btn-primary' style={{width: '100%'}}>
                                    <i className="bi bi-search"/> Search Asset
                                </button>
                            </div>
                        </div>
                        {loading && (
                            <div className="spinner-border text-primary" role="status" style={{marginTop: '12px'}}>
                                <span className="sr-only">{loading}</span>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* ══ TABS & CONTENT ══ */}
            <div className="al-grid-card" id="al-details-tabs-card">
                <Box sx={{width: '100%'}}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="asset details tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{
                                '& .MuiTab-root': {
                                    fontFamily: 'var(--font-body, "DM Sans", sans-serif)',
                                    fontWeight: 600,
                                    fontSize: '0.85rem',
                                    textTransform: 'none',
                                    color: 'var(--clr-muted, #64748b)',
                                    '&.Mui-selected': {
                                        color: '#0e8aca',
                                    },
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#0e8aca',
                                    height: 3,
                                },
                            }}
                        >
                            <Tab label="Information" {...a11yProps(0)} />
                            <Tab label="Capitalization" {...a11yProps(1)} />
                            <Tab label="Depreciation" {...a11yProps(2)} />
                            <Tab label="Allocation" {...a11yProps(3)} />
                            <Tab label="Repair Log" {...a11yProps(4)} />
                            <Tab label="Asset Images" {...a11yProps(5)} />
                            <Tab label="PV Information" {...a11yProps(6)} />
                        </Tabs>
                    </Box>

                    {/* TAB 0: Information */}
                    <TabPanel value={value} index={0}>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="TAG" inputValue={assetInfo.tag}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Parent TAG" inputValue={assetInfo.parent_tag}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Year of Addition" inputValue={assetInfo.year_of_addition}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Type of Addition" inputValue={assetInfo.type_of_addition}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Project Marking" inputValue={assetInfo.project_marking}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="PO No (If Any)" inputValue={assetInfo.po_no}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Supplier Code (if Any)" inputValue={assetInfo.supplier_code}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Name of the Supplier" inputValue={assetInfo.supplier_name}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Invoice No" inputValue={assetInfo.invoice_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Invoice Date" inputValue={assetInfo.invoice_date ? getFormatedDate(assetInfo.invoice_date) : ''}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Bill of Entry No" inputValue={assetInfo.boe_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Date of BOE" inputValue={assetInfo.boe_date ? getFormatedDate(assetInfo.boe_date) : ''}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Shipping / AWB No" inputValue={assetInfo.shipping_awb_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Date of Shipping/AWB" inputValue={assetInfo.shipping_awb_date ? getFormatedDate(assetInfo.shipping_awb_date) : ''}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Accounting Voucher No." inputValue={assetInfo.accounting_voucher_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Internal Approval No" inputValue={assetInfo.internal_approval_no}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Cost Center Code" inputValue={assetInfo.cost_center_code}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Cost Center Name" inputValue={assetInfo.cost_center_name}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Invoice Currency" inputValue={assetInfo.invoice_currency}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Exchange Rate" inputValue={parseFloat(assetInfo.exchange_rate).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Basic Cost p.u in Fx" inputValue={parseFloat(assetInfo.invoice_value_fx).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Basic Cost p.u in INR" inputValue={parseFloat(assetInfo.invoice_value_inr).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Forwarding & Insurance" inputValue={parseFloat(assetInfo.forwarding_and_insurance).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Installation" inputValue={parseFloat(assetInfo.installation).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Errection" inputValue={parseFloat(assetInfo.errection).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Total Cost Without Tax p.u" inputValue={parseFloat(assetInfo.total_cost_without_tax).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="customs" inputValue={parseFloat(assetInfo.customs).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="CGST" inputValue={parseFloat(assetInfo.cgst).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="SGST" inputValue={parseFloat(assetInfo.sgst).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="IGST" inputValue={parseFloat(assetInfo.igst).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Other Taxes" inputValue={parseFloat(assetInfo.other_taxes).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Total Tax p.u" inputValue={parseFloat(assetInfo.total_tax).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Total Cost with Tax p.u" inputValue={parseFloat(assetInfo.value_of_asset).toFixed(2)}/></div>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Qty" inputValue={parseFloat(assetInfo.qty).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Unit Of Measure" inputValue={assetInfo.unit_of_measure}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Name of the Asset (as per Invoice)" inputValue={assetInfo.asset_name}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Detailed Description of the Asset" inputValue={assetInfo.asset_description}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Nature of Presence" inputValue={assetInfo.nature_of_presence}/></div>
                        </div>
                        <div className='row'>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Nature of Addition" inputValue={assetInfo.nature_of_addition}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Principal Asset to which Cost is Added" inputValue={assetInfo.principal_asset_tag}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Unique Sl No of the Asset" inputValue={assetInfo.asset_serial_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Make / Manufacturer" inputValue={assetInfo.manufacturer}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Model No" inputValue={assetInfo.model_no}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Part No" inputValue={assetInfo.part_no}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="TAG" inputValue={assetInfo.tag}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Comp Ref. No." inputValue={assetInfo.comp_ref_no}/></div>
                        </div>
                        <div className='row'>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Asset TAG Name" inputValue={assetInfo.tag_name}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Asset TAG Branch" inputValue={assetInfo.tag_division}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Control Department" inputValue={(departments && departments.length) > 0 ? (departments.filter(option => assetInfo.ownership_id === option.id).map(option => option.department_name).join(', ')) : ('')}/></div>
                            <div className='col'><FromFieldText readOnly="readonly" label="Security Seal Date" inputValue={assetInfo.security_seal_date ? getFormatedDate(assetInfo.security_seal_date) : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                    </TabPanel>

                    {/* TAB 1: Capitalization */}
                    <TabPanel value={value} index={1}>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="TAG" inputValue={assetInfo.tag}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Class of Asset" inputValue={assetInfo.class_of_asset}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Record Start Date" inputValue={getFormatedDate(assetInfo.record_start_date)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Parent TAG" inputValue={assetInfo.parent_tag}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Depreciation mode" inputValue={assetInfo.cap_type_of_asset}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Date of Capitalization / Asset Ready To Use" inputValue={getFormatedDate(assetInfo.asset_in_use_date)}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Type of Depreciation" inputValue={assetInfo.type_of_depreciation}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Depreciation Rate (No. of years)" inputValue={assetInfo.depreciation_rate}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="End Date" inputValue={getFormatedDate(assetInfo.depreciation_end_date)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Accounting Code of Asset" inputValue={assetInfo.accounting_code}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Accounting Name of the Asset" inputValue={assetInfo.accounting_name}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Financials Classification" inputValue={assetInfo.category_name}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Put to Use Date [IT]" inputValue={getFormatedDate(assetInfo.put_to_use_date)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Final Asset Capitalization Flag" inputValue={assetInfo.capitalization_flag}/></div>
                            <div className='col-6'><FromFieldText readOnly="readonly" label="Is Tax Capitalized" inputValue={assetInfo.is_tax_capitalized}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Invoice Currency" inputValue={assetInfo.invoice_currency}/></div>
                            <div className='col-6'><FromFieldNumber readOnly="readonly" label="Exchange Rate" inputValue={parseFloat(assetInfo.exchange_rate).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Is 100% Depreciable Asset" inputValue={assetInfo.is_100_perc_depreciable}/></div>
                            <div className='col-6'><FromFieldNumber readOnly="readonly" label="Pre Capitalized Asset Value" inputValue={parseFloat(assetInfo.pre_capitalized_asset_value).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Is any other Accg GAAP Applicable" inputValue={assetInfo.is_any_other_accg_gaap_applicable}/></div>
                            <div className='col-6'><FromFieldNumber readOnly="readonly" label="I-GAAP - Limit for 100% Depreciable Asset (Rs)" inputValue={parseFloat(assetInfo.igaap_limit_amount).toFixed(2)}/></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldNumber readOnly="readonly" label="Salvage Value" inputValue={parseFloat(assetInfo.salvage_value).toFixed(2)}/></div>
                            <div className='col-6'><FromFieldNumber readOnly="readonly" label="Capitalized Value (I-GAAP)" inputValue={parseFloat(assetInfo.igaap_capitalized_value).toFixed(2)}/></div>
                        </div>
                        {((assetInfo.is_any_other_accg_gaap_applicable !== '' && assetInfo.is_any_other_accg_gaap_applicable == 'Yes')) && (
                            <div>
                                <div className="row">
                                    <h5 style={{marginTop: '20px', color: '#0e8aca', borderBottom: '2px solid #0e8aca', paddingBottom: '8px'}}>Other-GAAP</h5>
                                </div>
                                <div className="row">
                                    <div className="col-6"><FromFieldText star="*" label="Record Start Date [Other-GAAP]" inputValue={getFormatedDate(assetInfo.other_record_start_date)} readOnly="readonly"/></div>
                                    <div className="col-6"><FromFieldText star="*" label="Is 100% Depreciable Asset [Other-GAAP]" inputValue={assetInfo.is_100_perc_other_depreciable} readOnly="readonly"/></div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="row">
                                            <div className="col-md-6"><label> Depreciation Rate(No. of years) [Other-GAAP] <span className="star error"> * </span></label></div>
                                            <div className="col-md-6"><input type="number" value={parseFloat(assetInfo.other_depreciation_rate).toFixed(2)} className="form-control" placeholder="Depreciation Rate[Other-GAAP]" readOnly="readonly"/></div>
                                        </div>
                                    </div>
                                    <div className="col-6"><FromFieldText label="End Date [Other-GAAP]" inputValue={getFormatedDate(assetInfo.depreciation_other_end_date)} readOnly="readOnly"/></div>
                                </div>
                                <div className="row">
                                    <div className="col-6"><FromFieldNumber star="*" label="Other-GAAP - Limit for 100% Depreciable Asset (Rs)" inputValue={parseFloat(assetInfo.othergaap_limit_amount).toFixed(2)} readOnly="readonly"/></div>
                                    <div className="col-6"><FromFieldNumber star="*" label="Capitalized Value (Other GAAP)" inputValue={parseFloat(assetInfo.othergaap_capitalized_value).toFixed(2)} readOnly="readonly"/></div>
                                </div>
                            </div>
                        )}
                    </TabPanel>

                    {/* TAB 2: Depreciation */}
                    <TabPanel value={value} index={2}>
                        <Box sx={{height: 500, width: '100%'}}>
                            <DataGrid
                                rows={assetDepriciation}
                                getRowId={(row) => row.id}
                                columns={columns}
                                pageSize={50}
                                columnBuffer={50}
                                autoHeight
                                rowsPerPageOptions={[50]}
                                onCellEditStop={onCellEditStopFn}
                                components={{Toolbar: CustomToolbar}}
                                sx={{
                                    border: 'none',
                                    fontFamily: "var(--font-body)",
                                    '& .MuiDataGrid-columnHeaders': {
                                        color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                        textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                                    },
                                    '& .MuiDataGrid-columnHeaderTitle': {color: '#000',fontSize: '0.88rem'},
                                    '& .MuiDataGrid-row:hover': {backgroundColor: '#eef7fd'},
                                    '& .MuiDataGrid-cell': {borderColor: '#f0f2f5'},
                                }}
                            />
                        </Box>
                    </TabPanel>

                    {/* TAB 3: Allocation */}
                    <TabPanel value={value} index={3}>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="TAG" inputValue={(allocationInfo) ? allocationInfo.tag : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Division" inputValue={(allocationInfo) ? allocationInfo.division_name : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Premises" inputValue={(allocationInfo) ? allocationInfo.premises : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Floor" inputValue={(allocationInfo) ? allocationInfo.floor : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Site ID" inputValue={(allocationInfo) ? allocationInfo.site_id : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Rack Id" inputValue={(allocationInfo) ? allocationInfo.rack_id : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="User Type" inputValue={(allocationInfo) ? allocationInfo.user_type : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="User Department" inputValue={(allocationInfo) ? allocationInfo.user_department : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Employee ID" inputValue={(allocationInfo) ? allocationInfo.employee_id : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Employee Name" inputValue={(allocationInfo) ? allocationInfo.employee_name : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="User Mail ID" inputValue={(allocationInfo) ? allocationInfo.user_mail_id : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Eligible for Alternative Verification" inputValue={(allocationInfo) ? allocationInfo.alternative_verification : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Start Date of Allocation" inputValue={(allocationInfo) ? allocationInfo.effective_date : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                        <div className='row'>
                            <div className='col'><FromFieldText readOnly="readonly" label="Select for child allocation" inputValue={(allocationInfo) ? allocationInfo.child_allocation : ''}/></div>
                            <div className='col-6'></div>
                        </div>
                    </TabPanel>

                    {/* TAB 4: Repair Log */}
                    <TabPanel value={value} index={4}>
                        <Box sx={{height: 500, width: '100%'}}>
                            <DataGrid
                                rows={assetRepairLogs}
                                getRowId={(row) => row.id}
                                columns={columns1}
                                pageSize={50}
                                columnBuffer={50}
                                autoHeight
                                rowsPerPageOptions={[50]}
                                onCellEditStop={onCellEditStopFn}
                                components={{Toolbar: CustomToolbar}}
                                sx={{
                                    border: 'none',
                                    fontFamily: "var(--font-body)",
                                    '& .MuiDataGrid-columnHeaders': {
                                        color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                        textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                                    },
                                    '& .MuiDataGrid-columnHeaderTitle': {color: '#000',fontSize: '0.88rem'},
                                    '& .MuiDataGrid-row:hover': {backgroundColor: '#eef7fd'},
                                    '& .MuiDataGrid-cell': {borderColor: '#f0f2f5'},
                                }}
                            />
                        </Box>
                    </TabPanel>

                    {/* TAB 5: Asset Images */}
                    <TabPanel value={value} index={5}>
                        <div className="al-image-gallery">
                            {['front', 'back', 'left', 'right', 'top', 'bottom', 'other'].map(dimension => (
                                <div className="al-image-row" key={dimension}>
                                    <div className="al-image-label">
                                        <i className="bi bi-image-fill"/> {dimension.charAt(0).toUpperCase() + dimension.slice(1)} View
                                    </div>
                                    <div className="al-image-content">
                                        {imagelist.filter(opt => opt.asset_dimension === dimension).map(opt => (
                                            <img
                                                key={opt.asset_image}
                                                onClick={() => handlePreviewImage(opt.asset_image_url, opt.asset_image, dimension.charAt(0).toUpperCase() + dimension.slice(1))}
                                                className="al-image-thumb"
                                                src={opt.asset_image_url}
                                                alt={`${dimension} view`}
                                            />
                                        ))}
                                        {imagelist.filter(opt => opt.asset_dimension === dimension).length === 0 && (
                                            <span className="al-no-image"><i className="bi bi-image"/> No image available</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabPanel>

                    {/* TAB 6: PV Information */}
                    <TabPanel value={value} index={6}>
                        {assetInfo?.nature_of_presence === 'Identifiable' ? (
                            <Box sx={{width: '100%'}}>
                                <DataGrid
                                    rows={Array.isArray(pvInformationLog) ? pvInformationLog : []}
                                    getRowId={(row) => row.id}
                                    columns={columns2}
                                    initialState={{
                                        pagination: {paginationModel: {pageSize: 50, page: 0}},
                                    }}
                                    pageSizeOptions={[50]}
                                    autoHeight
                                    onCellEditStop={onCellEditStopFn}
                                    slots={{toolbar: CustomToolbar}}
                                    sx={{
                                        border: 'none',
                                        fontFamily: "var(--font-body)",
                                        '& .MuiDataGrid-columnHeaders': {
                                            color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                            textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                                        },
                                        '& .MuiDataGrid-columnHeaderTitle': {color: '#000',fontSize: '0.88rem'},
                                        '& .MuiDataGrid-row:hover': {backgroundColor: '#eef7fd'},
                                        '& .MuiDataGrid-cell': {borderColor: '#f0f2f5'},
                                    }}
                                />
                            </Box>
                        ) : (
                            <div className="row mt-2">
                                <div className="col-md-1"><label>Asset Type</label></div>
                                <div className='col-md-4'>
                                    <FromFieldTextER readOnly inputValue={assetInfo.nature_of_presence}/>
                                </div>
                            </div>
                        )}
                    </TabPanel>
                </Box>
            </div>

            {/* ══ IMAGE PREVIEW MODAL ══ */}
            {showModal && (
                <div className="al-modal-backdrop" id="al-modal" onClick={() => setShowModal(false)}>
                    <div className="al-modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="al-modal-header">
                            <div className="al-modal-title">
                                <div className="al-modal-title-icon"><i className="bi bi-image"/></div>
                                <span>{head_title} — Image Preview</span>
                            </div>
                            <div className="al-modal-header-actions">
                                <button className="al-btn al-btn-primary al-btn-sm" onClick={() => handleDownloadFile(imageName, '1')}>
                                    <i className="bi bi-download"/> Download
                                </button>
                                <button className="al-btn al-btn-danger al-btn-sm" onClick={() => setShowModal(false)}>
                                    <i className="bi bi-x-lg"/>
                                </button>
                            </div>
                        </div>
                        <div className="al-modal-body">
                            <img src={previewImage} alt="Preview" className="al-modal-img"/>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AssetDetails